import {createSlice, createAsyncThunk, PayloadAction} from '@reduxjs/toolkit'
import campusService from './campusService'

// Get Campuses
// export const ListCampus = createAsyncThunk('Campus-list', async (params: {}, thunkAPI) => {
//   try {
//     return await campusService.campusList({params})
//   } catch (error: any) {
//     if (error.response.data) {
//       return thunkAPI.rejectWithValue(error.response.data.errors)
//     }
//   }
// })
import axios from 'axios'

const api = '/api/'

// Single optimized thunk (no service boilerplate)
export const ListCampus = createAsyncThunk(
  'campus/list',
  async (params: Record<string, any>, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}campus/list`, {params})
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

// Create Campus
export const createCampus = createAsyncThunk('Campus-create', async (data: {}, thunkAPI) => {
  try {
    return await campusService.campusCreate({data})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Get Campus id
export const editCampus = createAsyncThunk('Campus-edit', async (id: string, thunkAPI) => {
  try {
    return await campusService.campusEdit(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const deleteCampus = createAsyncThunk('Campus-edit', async (id: string, thunkAPI) => {
  try {
    return await campusService.campusDelete(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const ListCampusUnit = createAsyncThunk('Campus-unit-list', async (params: {}, thunkAPI) => {
  try {
    return await campusService.campusUnitList({params})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const createCampusUnit = createAsyncThunk(
  'Campus-unit-create',
  async (data: {}, thunkAPI) => {
    try {
      return await campusService.campusUnitCreate({data})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const editCampusUnit = createAsyncThunk('Campus-unit-edit', async (id: string, thunkAPI) => {
  try {
    return await campusService.campusUnitEdit(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const viewCampusUnit = createAsyncThunk('Campus-unit-view', async (id: string, thunkAPI) => {
  try {
    return await campusService.campusUnitView(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const deleteCampusUnit = createAsyncThunk('Campus-edit', async (id: string, thunkAPI) => {
  try {
    return await campusService.campusUnitDelete(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const ListGrading = createAsyncThunk('grading-list', async (_, thunkAPI) => {
  try {
    return await campusService.GradingList()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const ListFaculty = createAsyncThunk('faculty-list', async (params: {}, thunkAPI) => {
  try {
    return await campusService.facultyList({params})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Create Campus
export const createFaculty = createAsyncThunk('faculty-create', async (data: {}, thunkAPI) => {
  try {
    return await campusService.facultyCreate({data})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Get Campus id
export const editFaculty = createAsyncThunk('faculty-edit', async (id: string, thunkAPI) => {
  try {
    return await campusService.facultyEdit(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const deleteFaculty = createAsyncThunk('faculty-edit', async (id: string, thunkAPI) => {
  try {
    return await campusService.facultyDelete(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const ListDepartment = createAsyncThunk('dep-list', async (faculty_id: string, thunkAPI) => {
  try {
    return await campusService.departmentList(faculty_id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Create Campus
export const createDepartment = createAsyncThunk(
  'department-create',
  async (data: {}, thunkAPI) => {
    try {
      return await campusService.departmentCreate({data})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get Campus id
export const editDepartment = createAsyncThunk('department-edit', async (id: string, thunkAPI) => {
  try {
    return await campusService.departmentEdit(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const deleteDepartment = createAsyncThunk(
  'department-edit',
  async (id: string, thunkAPI) => {
    try {
      return await campusService.departmentDelete(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const ListCuFaculty = createAsyncThunk('cu-faculty-list', async (params: {}, thunkAPI) => {
  try {
    return await campusService.cuFacultyList({params})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const createCuFaculty = createAsyncThunk('cu-faculty-create', async (data: {}, thunkAPI) => {
  try {
    return await campusService.cuFacultyCreate({data})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const editCuFaculty = createAsyncThunk('cu-faculty-edit', async (id: string, thunkAPI) => {
  try {
    return await campusService.cuFacultyEdit(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const deleteCuFaculty = createAsyncThunk('cu-faculty-edit', async (id: string, thunkAPI) => {
  try {
    return await campusService.cuFacultyDelete(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const ListCuDepartment = createAsyncThunk(
  'cu-department-list',
  async (params: {}, thunkAPI) => {
    try {
      return await campusService.cuDepartmentList({params})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const createCuDepartment = createAsyncThunk(
  'cu-department-create',
  async (data: {}, thunkAPI) => {
    try {
      return await campusService.cuDepartmentCreate({data})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const editCuDepartment = createAsyncThunk(
  'cu-department-edit',
  async (id: string, thunkAPI) => {
    try {
      return await campusService.cuDepartmentEdit(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const deleteCuDepartment = createAsyncThunk(
  'cu-department-edit',
  async (id: string, thunkAPI) => {
    try {
      return await campusService.cuDepartmentDelete(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const GetDepartments = createAsyncThunk('get-departments', async (id: string, thunkAPI) => {
  try {
    return await campusService.getDeps(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const ListSubject = createAsyncThunk('subject-list', async (params: {}, thunkAPI) => {
  try {
    return await campusService.subjectList({params})
  } catch (error: any) {
    if (error.response?.data?.errors) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
    return thunkAPI.rejectWithValue(error.message)
  }
})

// Create Campus
export const createSubject = createAsyncThunk('subject-create', async (data: {}, thunkAPI) => {
  try {
    return await campusService.subjectCreate({data})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Get Campus id
export const editSubject = createAsyncThunk('subject-edit', async (id: string, thunkAPI) => {
  try {
    return await campusService.subjectEdit(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const SubjectSwitchStatus = createAsyncThunk(
  'subject-switch-status',
  async (id: string, thunkAPI) => {
    try {
      return await campusService.subjectSwitchStatus(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

type CampusState = {
  errors: any
}

const initialState: CampusState = {
  errors: '',
}

export const campusSlice = createSlice({
  name: 'campus',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(createFaculty.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
  },
})

export const {reset} = campusSlice.actions
export default campusSlice.reducer
